import {
  cloneAndPrepSvg,
  convertTextNodesToPaths,
  inlinePngUserIconDataUrlsForSvgExport,
  normalizeAlphaPaintsForSvgExport,
} from './exportHelpers';
import { PRINTING_SHEET } from './moldGeometry';

// The order processing's printing files (ProcessOrderScreen, out of it in chain 12): the
// question asked before a download while a preview setting is on, and a run's rendered SVG
// prepared for its file, sized as the sheet every run prints on (PRINTING_SHEET, moldGeometry.js).

// the seven settings the download asks about first, in the order the question names them: off by default, meant for the preview; the punching holes and the mold border, on by default, are part of every file (exported for its test)
export const PREVIEW_SETTINGS = [
  ['show2x2Grid', '2x2 Grid'],
  ['show3x3Grid', '3x3 Grid'],
  ['showPrintableArea', 'Printable Area'],
  ['showTopSurface', 'Top Surface'],
  ['showShadows', 'Shadows'],
  ['showLabels', 'Labels'],
  ['showScrewHoles', 'Screw Holes'],
];

export const printingSettingsWarning = (settings) => {
  const activeSettings = PREVIEW_SETTINGS.filter(([key]) => settings[key]).map(
    ([, name]) => name
  );

  if (activeSettings.length === 0) return null;
  if (activeSettings.length === 1) {
    return `${activeSettings[0]} is currently enabled. Are you sure you want to download the files with this setting enabled?`;
  }

  const lastSetting = activeSettings.pop();
  return `${activeSettings.join(', ')} and ${lastSetting} are currently enabled. Are you sure you want to download the files with these settings enabled?`;
}; // the question the PDF and SVG buttons put to the admin while a preview setting is on (window.confirm in the screen), null when none is

export const preparePrintingSvg = async (svgEl, fonts) => {
  const clone = cloneAndPrepSvg(
    svgEl,
    PRINTING_SHEET.width,
    PRINTING_SHEET.height
  ); // a clone sized as the sheet, without the elements marked for the preview alone
  convertTextNodesToPaths(clone, fonts); // every <text> to a <path> first, so the alpha split below reaches the paths' paints too
  await inlinePngUserIconDataUrlsForSvgExport(clone); // the uploaded PNG icons' signed links replaced with embedded data URLs
  normalizeAlphaPaintsForSvgExport(clone); // rgba and #RRGGBBAA split into a colour and an opacity, which Inkscape needs
  return clone;
}; // the rendered SVG of a run (PrintingRunSvg) as the printing file holds it; the screen serialises it to the SVG file or renders it to the PDF
